var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWinterLevel7MRFinished(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 76,
    viewBox: "0 0 105 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.110928 52.3129L0.0929527 58.2076C0.0929527 58.2076 -0.805641 61.802 4.13662 63.1499C9.07889 64.4978 4.58592 63.1499 4.58592 63.1499L45.9212 74.8316C45.9212 74.8316 50.4142 76.6288 54.0086 75.7302L54.4579 64.9471L20.7606 45.6273L0.110928 52.3129Z",
    fill: "#946E3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.431 49.6173C103.431 49.6712 103.881 55.9614 103.881 55.9614C103.881 55.9614 104.779 59.5558 102.533 60.9036C102.533 60.9036 61.6468 74.3825 61.1975 74.3825C60.7482 74.3825 56.2553 75.2811 54.0088 75.7304V62.2515L103.431 49.6173Z",
    fill: "#8B6838"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26826 48.7142C7.26826 48.7142 -7.43722 52.6365 5.2644 54.5954L45.3776 65.0506C45.3776 65.0506 53.8244 69.256 63.7628 64.3991C64.4323 64.0711 100.533 51.9806 100.533 51.9806C100.533 51.9806 107.888 49.3656 99.1944 46.4272L60.4201 33.6852C60.4201 33.6852 54.404 31.7262 48.7204 34.6646L7.27276 48.7142H7.26826Z",
    fill: "#9F753F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.604 49.4823C18.604 49.4823 7.3985 52.7352 17.1393 54.1325L47.952 61.8963C47.952 61.8963 54.4623 65.1043 62.0105 61.1685C62.5182 60.9034 89.9972 50.9784 89.9972 50.9784C89.9972 50.9784 95.591 48.8353 88.9099 46.6247L59.0901 37.0502C59.0901 37.0502 54.4623 35.5765 50.1491 37.9578L18.604 49.4868V49.4823Z",
    fill: "#B08245"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6795 19.1548L33.9117 18.4629C33.3905 16.5354 33.5074 6.06233 33.9746 5.24461C38.5709 4.80879 65.3311 6.57004 65.5422 6.58352C65.7534 6.597 66.2117 18.0855 66.2117 18.0855C66.2117 18.0855 48.8329 55.8264 48.6936 55.8175C48.5543 55.8085 35.9291 54.0203 33.3276 51.621L50.6795 19.1548Z",
    fill: "#B08245",
    stroke: "#B08245",
    strokeWidth: 9,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6795 19.1548L33.9117 18.4629C33.3905 16.5354 33.5074 6.06233 33.9746 5.24461C38.5709 4.80879 65.3311 6.57004 65.5422 6.58352C65.7534 6.597 66.2117 18.0855 66.2117 18.0855C66.2117 18.0855 48.8329 55.8264 48.6936 55.8175C48.5543 55.8085 35.9291 54.0203 33.3276 51.621L50.6795 19.1548Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinterLevel7MRFinished);
export default __webpack_public_path__ + "static/media/winter_level_7_m_r_finished.25681b3e0fc2875bc8b7c6e027f13792.svg";
export { ForwardRef as ReactComponent };